import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DeliveryNoteItemFacade } from './delivery-note-item.facade';
import { loadStoreState, setInitialStoreState } from '../../../../common/utils';
import { DeliveryNoteOverviewFacade } from './overview/delivery-note-overview.facade';

@Injectable({
  providedIn: 'root',
})
export class DeliveryNoteItemGuard {
  constructor(
    private deliveryNoteItemFacade: DeliveryNoteItemFacade,
    private deliveryNoteOverviewFacade: DeliveryNoteOverviewFacade,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { deliveryNoteNumber },
      queryParams: { sapId, monitoringPageType },
    } = route;

    this.deliveryNoteItemFacade.setDeliveryNoteParams({ deliveryNoteNumber, sapId, monitoringPageType });
    return loadStoreState(this.deliveryNoteOverviewFacade, { deliveryNoteNumber, sapId, monitoringPageType });
  }

  canDeactivate(): boolean {
    setInitialStoreState(this.deliveryNoteOverviewFacade);
    return setInitialStoreState(this.deliveryNoteItemFacade);
  }
}
